<app-router-link
  [params]="routerLinkParams()"
  [route]="Route.PL_BoxDetails"
  queryParamsHandling="preserve">
  <app-public-box-tile-image
    [availability]="availability()"
    [imageAlt]="imageAlt()"
    [imageSrc]="imageSrc()" />
</app-router-link>

<app-public-box-tile-details
  [date]="date()"
  [name]="name()"
  [rating]="rating()"
  [votes]="votes()" />
